import { loadable } from '../../../utils';

export const Basic = loadable(() => import('./Basic'), {});
export const PostalCode = loadable(() => import('./PostalCode'), {});
export const ImportWizard = loadable(() => import('./ImportWizard'), {});
